/**
 * @author Jersson Morales
 * @Copyright (c) Infotrack. All rights reserved.
 */
import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import RefreshIcon from '@material-ui/icons/Refresh';
import { Action, Column, Options } from '@infotrack/presentacion-componentes/tabla';
import { TipoFormulario } from '@infotrack/presentacion-transversales/interfacesComunes';
import ITipoSociedad from 'Infotrack@Modelos/administracion/tipoSociedad/entidades/tipoSociedad';
import { BotonAgregar, BotonRefrescar } from 'Infotrack@Transversales/componentes/botonesAcciones';
import React from 'react';
import { FormattedMessage } from 'react-intl';

export const columnas = (
    formatMessage: (params: FormattedMessage.MessageDescriptor) => string
): Array<Column<ITipoSociedad>> => [
    {
        title: formatMessage({ id: 'tipoSociedad.codigoTipoSociedad' }),
        field: 'CodigoTipoSociedad',
    },
    {
        title: formatMessage({ id: 'tipoSociedad.nombreTipoSociedad' }),
        field: 'NombreTipoSociedad',
    },
    {
        title: formatMessage({ id: 'tipoSociedad.estadoTipoSociedad' }),
        field: 'EstadoTipoSociedad',
        type: 'boolean',
    },
];

export const acciones = (
    manejarFormulario: (tipoFormulario: TipoFormulario, tipoSociedad?: ITipoSociedad) => void,
    cargarTipoSociedad: () => void,
    formatMessage: (params: FormattedMessage.MessageDescriptor) => string,
    confirmarEliminacion: (tipoSociedad: ITipoSociedad) => void
): Array<Action<ITipoSociedad>> => [
    {
        component: BotonAgregar,
        icon: () => <AddIcon />,
        onClick: () => manejarFormulario(TipoFormulario.Creacion, undefined),
        isFreeAction: true,
        tooltip: formatMessage({ id: 'boton.agregar' }),
    },
    {
        icon: () => <EditIcon color="action" />,
        onClick: (_, value) => manejarFormulario(TipoFormulario.Edicion, value as ITipoSociedad),
        tooltip: formatMessage({ id: 'boton.editar' }),
    },
    {
        component: BotonRefrescar,
        icon: () => <RefreshIcon />,
        onClick: cargarTipoSociedad,
        isFreeAction: true,
        tooltip: formatMessage({ id: 'boton.refrescar' }),
    },
    {
        icon: () => <DeleteIcon color="action" />,
        onClick: (_, value) => confirmarEliminacion(value as ITipoSociedad),
        tooltip: formatMessage({ id: 'boton.eliminar' }),
    },
];

export const opciones: Options<ITipoSociedad> = {
    maxBodyHeight: '50vh',
};
